export default __webpack_public_path__ + "static/media/incomplete-solution.08bc0255.svg";